import { createSelector } from "reselect"
import { getProfile } from "./profile.selector"
import { RootState } from "../modules"
import { TagType, SelectedTag } from "../models/ TagType"
import { createDeepEqualSelector } from "./util.selector"
import { isLoaded, isEmpty } from "react-redux-firebase"
import { getAreas } from "./lookahead.selector"
import { Area } from "../models/Area"

export const isProjectDialogOpenSelector = createSelector([state => 
    state.homeView.isProjectDialogOpen, getProfile], (isProjectDialogOpen, profile) => {

        
    if(!profile || !isLoaded(profile) || isEmpty(profile)) return false

    if (!profile.projects || Object.keys(profile.projects).length <= 0) return true

    return isProjectDialogOpen
})

export const isPrintBoardOpen = (state:any) => state.dialogReducer.isPrintBoardOpen

export const isTagDialogOpen = (state:any) => state.dialogReducer.isTagDialogOpen

export const isTradeDialogOpen = (state:any) => state.dialogReducer.isTradeDialogOpen

export const isPhasePlanDialogOpen = (state:any) => state.dialogReducer.isPhasePlanDialogOpen

export const isMRPCreateDialogOpen = (state:any) => state.dialogReducer.isMRPDialogOpen

export const getCopiedPhaseTags = (state:any): Record<string, SelectedTag> => state.dialogReducer.copiedPhaseTags

export const getCopiedLookaheadTags = (state:any): Record<string, SelectedTag> => state.dialogReducer.copiedLookaheadTags

export const isEditAreaDialogOpen = (state:any): boolean => state.dialogReducer.isEditAreaDialogOpen
export const isEditAreaZoneDialogOpen = (state:any): boolean => state.dialogReducer.isEditAreaZoneDialogOpen

export const getEditAreaDialogKey = (state:any): string => state.dialogReducer.areaKey


const getSimpleTagData = (tag: any) => {
    return {
        uid: tag.uid,
        name: tag.name,
        tagCardType: tag.tagCardType,
        tradeId: tag.tradeId,
        tagDate: tag.tagDate,
        status: tag.status,
        crewSize: tag.crewSize,
        locationId: tag.locationId,
    };
}

export const makeGetAreaData = () => {
    return createSelector(
        [getEditAreaDialogKey, getAreas],
        (uid: string, areas: Record<string, Area>) => {

            if(!!areas[uid]) return areas[uid]

            return null;
        }
    );
}

export const getCopiedLookaheadTagsCount =  createDeepEqualSelector([getCopiedLookaheadTags], (tags) => {
    if(!tags || Object.keys(tags).length <= 0 ){
        return 0
    }

    return Object.keys(tags).length
})

export const isRowCountDialogOpen = (state:any) => state.dialogReducer.rowCountDialogInfo !== null

export const rowCountRow = (state:any) => state.dialogReducer.rowCountDialogInfo



export const isImportScheduleDialogOpen = (state:any) => state.homeView.isImportScheduleDialogOpen

export const isUploadTasksDialogOpen = (state:any) => state.homeView.isUploadTasksDialogOpen

export const isLookaheadTagDialogOpen = (state: any) => state.lookaheadReducer.lookaheadTagDialogOpen

export const isConstraintDialogOpen = (state: any) => state.dialogReducer.isConstraintDialogOpen

export const isInviteDialogOpen = (state:any) => state.homeView.isInviteDialogOpen

export const isBatchTagDialogOpen = (state:any) => !!state.dialogReducer.batchTagIds && Object.keys(state.dialogReducer.batchTagIds).length > 0

export const getBatchIds = (state:any): Record<string, SelectedTag> => !!state.dialogReducer.batchTagIds ? state.dialogReducer.batchTagIds : {}

export const isDialogOpen = createSelector(
    [
        
        isUploadTasksDialogOpen,
        isProjectDialogOpenSelector,
        isLookaheadTagDialogOpen, 
        isTradeDialogOpen, 
        isConstraintDialogOpen,
        isPhasePlanDialogOpen, 
        isTagDialogOpen,
        isInviteDialogOpen,
        isBatchTagDialogOpen,
        isRowCountDialogOpen,
        isPrintBoardOpen,
        isMRPCreateDialogOpen
    ], 
    (
        isUploadTasksDialogOpen, 
        isProjectDialogOpenSelector, 
        isLookaheadTagDialogOpen, 
        isTradeDialogOpen, 
        isConstraintDialogOpen,
        isPhasePlanDialogOpen,
        isTagDialogOpen,
        _isInviteDialogOpen,
        isBatchTagDialogOpen,
        isRowCountDialogOpen,
        isPrintBoardOpen,
        isMRPCreateDialogOpen
    ) => {

        if(isPrintBoardOpen || isRowCountDialogOpen || isUploadTasksDialogOpen || isProjectDialogOpenSelector || isLookaheadTagDialogOpen || isTradeDialogOpen || isConstraintDialogOpen || isPhasePlanDialogOpen || isTagDialogOpen || _isInviteDialogOpen || isBatchTagDialogOpen || isMRPCreateDialogOpen) {
            return true
        }

        return false
})





// WEBPACK FOOTER //
// ./src/selectors/dialog.selector.tsx